export default "__VITE_ASSET__DSy87SgK__"